import SETTINGS from '#/config/global-settings';

export function ethereumTxUrl(txHash: string): string {
  return `${SETTINGS.ethereum.explorerUrl}tx/${txHash}`;
}
